<div class="rs-dialog narrow">
  <h2 mat-dialog-title class="title">Export debug info</h2>

  <div class="dialog-content" mat-dialog-content>
    <div class="content" *ngIf="state === 'unavailable'">
      <p class="warning">
        Open a robot before exporting debug info. Without a project and robot selected there is nothing for the export
        to point at, so nothing has been collected.
      </p>
    </div>

    <div class="content collecting" *ngIf="state === 'collecting'">
      <mat-spinner diameter="24"></mat-spinner>
      <p>Collecting evidence… fetching agent logs</p>
    </div>

    <div class="content" *ngIf="state === 'done'">
      <p>Debug info downloaded and summary copied to clipboard.</p>
      <p class="note" *ngIf="!agentLogAvailable">
        Agent logs were unavailable — the robot may be offline. The bundle still contains everything else.
      </p>
    </div>

    <div class="content" *ngIf="state === 'failed'">
      <p class="warning">Something went wrong collecting the debug info: {{ errorMessage }}</p>
    </div>
  </div>

  <div mat-dialog-actions align="end">
    <button app-mat-button *ngIf="state === 'collecting'" (click)="onCancel()">Cancel</button>
    <button app-mat-button color="primary" *ngIf="state !== 'collecting'" (click)="onClose()">Close</button>
  </div>
</div>
